import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MemoryInput } from "../components/memory/MemoryInput";
import { MemoryResult } from "../components/memory/MemoryResult";
import { analyzeCreatorMemory } from "../components/memory/memoryApi";
import { usePageMeta } from "../lib/usePageMeta";
import "../components/memory/memory.css";

const newSession = () => crypto.randomUUID();

export default function MemoryCreatorPage() {
  usePageMeta("What Kind of Creator Are You? — HUMN AI", "Tell Humn Ai one favorite life happening and discover the creator personality already inside it.");
  const [phase, setPhase] = useState("question");
  const [memory, setMemory] = useState("");
  const [photo, setPhoto] = useState(null);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [status, setStatus] = useState("Humn Ai is reading your vibe… ✦");
  const sessionRef = useRef(newSession());

  useEffect(() => {
    document.documentElement.classList.add("memory-route-active");
    return () => document.documentElement.classList.remove("memory-route-active");
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    if (memory.trim().length < 8) { setError("Tell Humn Ai one moment you still think about."); return; }
    setError(""); setPhase("analyzing");
    try {
      const [creator] = await Promise.all([
        analyzeCreatorMemory({ memory: memory.trim(), photo, sessionId: sessionRef.current, onStatus: setStatus }),
        new Promise((resolve) => window.setTimeout(resolve, 1400)),
      ]);
      setResult(creator); setPhase("result");
    } catch (requestError) {
      setError(requestError.message); setPhase("question");
    }
  };

  const retry = () => {
    sessionRef.current = newSession();
    setMemory(""); setPhoto(null); setResult(null); setError(""); setStatus("Humn Ai is reading your vibe… ✦"); setPhase("question");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return <main className={`memory-page is-${phase}`} data-testid="memory-creator-page"><div className="memory-shell">
    <img className="memory-logo" src="/brand/humn-wordmark.png" alt="HUMN" data-testid="memory-logo"/>
    <AnimatePresence mode="wait" initial={false}>
      {phase === "question" && <motion.div key="question" className="memory-phase" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0, y: -12 }}><MemoryInput memory={memory} setMemory={setMemory} photo={photo} setPhoto={setPhoto} sessionId={sessionRef.current} error={error} setError={setError} onSubmit={submit}/></motion.div>}
      {phase === "analyzing" && <motion.section key="analyzing" className="memory-processing" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} aria-live="polite" data-testid="memory-analyzing-state"><div aria-hidden="true"/><p data-testid="memory-analyzing-message">{status}</p></motion.section>}
      {phase === "result" && result && <motion.div key="result" className="memory-phase" initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .55 }}><MemoryResult result={result} onRetry={retry}/></motion.div>}
    </AnimatePresence>
  </div></main>;
}